/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TwoFactorRouteImport } from './routes/two-factor'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as ShareTokenRouteImport } from './routes/share.$token'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as InviteIdRouteImport } from './routes/invite/$id'
import { Route as AuthUsageRouteImport } from './routes/_auth/usage'
import { Route as AuthTenantUsageRouteImport } from './routes/_auth/tenant-usage'
import { Route as AuthSpeakersRouteImport } from './routes/_auth/speakers'
import { Route as AuthSettingsRouteImport } from './routes/_auth/settings'
import { Route as AuthSearchRouteImport } from './routes/_auth/search'
import { Route as AuthProviderCreditsRouteImport } from './routes/_auth/provider-credits'
import { Route as AuthPlatformBillingRouteImport } from './routes/_auth/platform-billing'
import { Route as AuthPipelineRunsRouteImport } from './routes/_auth/pipeline-runs'
import { Route as AuthPipelineRouteImport } from './routes/_auth/pipeline'
import { Route as AuthMembersRouteImport } from './routes/_auth/members'
import { Route as AuthJargonRouteImport } from './routes/_auth/jargon'
import { Route as AuthDiagnosticsRouteImport } from './routes/_auth/diagnostics'
import { Route as AuthCampaignsRouteImport } from './routes/_auth/campaigns'
import { Route as AuthAuditRouteImport } from './routes/_auth/audit'
import { Route as AuthAskRouteImport } from './routes/_auth/ask'
import { Route as AuthCompaniesIndexRouteImport } from './routes/_auth/companies/index'
import { Route as AuthMeetingsIdRouteImport } from './routes/_auth/meetings/$id'
import { Route as AuthCompaniesIdRouteImport } from './routes/_auth/companies/$id'
import { Route as AuthCampaignsIdRouteImport } from './routes/_auth/campaigns_.$id'
import { Route as AuthMeetingsIdViewerRouteImport } from './routes/_auth/meetings/$id_.viewer'
import { Route as AuthMeetingsIdTranscriptRouteImport } from './routes/_auth/meetings/$id_.transcript'
import { Route as AuthCompaniesIdSpeakersRouteImport } from './routes/_auth/companies/$id_.speakers'
import { Route as AuthCompaniesIdSettingsRouteImport } from './routes/_auth/companies/$id_.settings'
import { Route as AuthCompaniesIdDiagnosticsRouteImport } from './routes/_auth/companies/$id_.diagnostics'

const TwoFactorRoute = TwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteIdRoute = InviteIdRouteImport.update({
  id: '/invite/$id',
  path: '/invite/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthUsageRoute = AuthUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTenantUsageRoute = AuthTenantUsageRouteImport.update({
  id: '/tenant-usage',
  path: '/tenant-usage',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSpeakersRoute = AuthSpeakersRouteImport.update({
  id: '/speakers',
  path: '/speakers',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSearchRoute = AuthSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProviderCreditsRoute = AuthProviderCreditsRouteImport.update({
  id: '/provider-credits',
  path: '/provider-credits',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPlatformBillingRoute = AuthPlatformBillingRouteImport.update({
  id: '/platform-billing',
  path: '/platform-billing',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPipelineRunsRoute = AuthPipelineRunsRouteImport.update({
  id: '/pipeline-runs',
  path: '/pipeline-runs',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPipelineRoute = AuthPipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMembersRoute = AuthMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AuthRoute,
} as any)
const AuthJargonRoute = AuthJargonRouteImport.update({
  id: '/jargon',
  path: '/jargon',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDiagnosticsRoute = AuthDiagnosticsRouteImport.update({
  id: '/diagnostics',
  path: '/diagnostics',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCampaignsRoute = AuthCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuditRoute = AuthAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAskRoute = AuthAskRouteImport.update({
  id: '/ask',
  path: '/ask',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCompaniesIndexRoute = AuthCompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMeetingsIdRoute = AuthMeetingsIdRouteImport.update({
  id: '/meetings/$id',
  path: '/meetings/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCompaniesIdRoute = AuthCompaniesIdRouteImport.update({
  id: '/companies/$id',
  path: '/companies/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCampaignsIdRoute = AuthCampaignsIdRouteImport.update({
  id: '/campaigns_/$id',
  path: '/campaigns/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMeetingsIdViewerRoute = AuthMeetingsIdViewerRouteImport.update({
  id: '/meetings/$id_/viewer',
  path: '/meetings/$id/viewer',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMeetingsIdTranscriptRoute =
  AuthMeetingsIdTranscriptRouteImport.update({
    id: '/meetings/$id_/transcript',
    path: '/meetings/$id/transcript',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthCompaniesIdSpeakersRoute = AuthCompaniesIdSpeakersRouteImport.update({
  id: '/companies/$id_/speakers',
  path: '/companies/$id/speakers',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCompaniesIdSettingsRoute = AuthCompaniesIdSettingsRouteImport.update({
  id: '/companies/$id_/settings',
  path: '/companies/$id/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCompaniesIdDiagnosticsRoute =
  AuthCompaniesIdDiagnosticsRouteImport.update({
    id: '/companies/$id_/diagnostics',
    path: '/companies/$id/diagnostics',
    getParentRoute: () => AuthRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/two-factor': typeof TwoFactorRoute
  '/ask': typeof AuthAskRoute
  '/audit': typeof AuthAuditRoute
  '/campaigns': typeof AuthCampaignsRoute
  '/diagnostics': typeof AuthDiagnosticsRoute
  '/jargon': typeof AuthJargonRoute
  '/members': typeof AuthMembersRoute
  '/pipeline': typeof AuthPipelineRoute
  '/pipeline-runs': typeof AuthPipelineRunsRoute
  '/platform-billing': typeof AuthPlatformBillingRoute
  '/provider-credits': typeof AuthProviderCreditsRoute
  '/search': typeof AuthSearchRoute
  '/settings': typeof AuthSettingsRoute
  '/speakers': typeof AuthSpeakersRoute
  '/tenant-usage': typeof AuthTenantUsageRoute
  '/usage': typeof AuthUsageRoute
  '/invite/$id': typeof InviteIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/share/$token': typeof ShareTokenRoute
  '/campaigns/$id': typeof AuthCampaignsIdRoute
  '/companies/$id': typeof AuthCompaniesIdRoute
  '/meetings/$id': typeof AuthMeetingsIdRoute
  '/companies/': typeof AuthCompaniesIndexRoute
  '/companies/$id/diagnostics': typeof AuthCompaniesIdDiagnosticsRoute
  '/companies/$id/settings': typeof AuthCompaniesIdSettingsRoute
  '/companies/$id/speakers': typeof AuthCompaniesIdSpeakersRoute
  '/meetings/$id/transcript': typeof AuthMeetingsIdTranscriptRoute
  '/meetings/$id/viewer': typeof AuthMeetingsIdViewerRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/two-factor': typeof TwoFactorRoute
  '/ask': typeof AuthAskRoute
  '/audit': typeof AuthAuditRoute
  '/campaigns': typeof AuthCampaignsRoute
  '/diagnostics': typeof AuthDiagnosticsRoute
  '/jargon': typeof AuthJargonRoute
  '/members': typeof AuthMembersRoute
  '/pipeline': typeof AuthPipelineRoute
  '/pipeline-runs': typeof AuthPipelineRunsRoute
  '/platform-billing': typeof AuthPlatformBillingRoute
  '/provider-credits': typeof AuthProviderCreditsRoute
  '/search': typeof AuthSearchRoute
  '/settings': typeof AuthSettingsRoute
  '/speakers': typeof AuthSpeakersRoute
  '/tenant-usage': typeof AuthTenantUsageRoute
  '/usage': typeof AuthUsageRoute
  '/invite/$id': typeof InviteIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/share/$token': typeof ShareTokenRoute
  '/': typeof AuthIndexRoute
  '/campaigns/$id': typeof AuthCampaignsIdRoute
  '/companies/$id': typeof AuthCompaniesIdRoute
  '/meetings/$id': typeof AuthMeetingsIdRoute
  '/companies': typeof AuthCompaniesIndexRoute
  '/companies/$id/diagnostics': typeof AuthCompaniesIdDiagnosticsRoute
  '/companies/$id/settings': typeof AuthCompaniesIdSettingsRoute
  '/companies/$id/speakers': typeof AuthCompaniesIdSpeakersRoute
  '/meetings/$id/transcript': typeof AuthMeetingsIdTranscriptRoute
  '/meetings/$id/viewer': typeof AuthMeetingsIdViewerRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/two-factor': typeof TwoFactorRoute
  '/_auth/ask': typeof AuthAskRoute
  '/_auth/audit': typeof AuthAuditRoute
  '/_auth/campaigns': typeof AuthCampaignsRoute
  '/_auth/diagnostics': typeof AuthDiagnosticsRoute
  '/_auth/jargon': typeof AuthJargonRoute
  '/_auth/members': typeof AuthMembersRoute
  '/_auth/pipeline': typeof AuthPipelineRoute
  '/_auth/pipeline-runs': typeof AuthPipelineRunsRoute
  '/_auth/platform-billing': typeof AuthPlatformBillingRoute
  '/_auth/provider-credits': typeof AuthProviderCreditsRoute
  '/_auth/search': typeof AuthSearchRoute
  '/_auth/settings': typeof AuthSettingsRoute
  '/_auth/speakers': typeof AuthSpeakersRoute
  '/_auth/tenant-usage': typeof AuthTenantUsageRoute
  '/_auth/usage': typeof AuthUsageRoute
  '/invite/$id': typeof InviteIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/share/$token': typeof ShareTokenRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/campaigns_/$id': typeof AuthCampaignsIdRoute
  '/_auth/companies/$id': typeof AuthCompaniesIdRoute
  '/_auth/meetings/$id': typeof AuthMeetingsIdRoute
  '/_auth/companies/': typeof AuthCompaniesIndexRoute
  '/_auth/companies/$id_/diagnostics': typeof AuthCompaniesIdDiagnosticsRoute
  '/_auth/companies/$id_/settings': typeof AuthCompaniesIdSettingsRoute
  '/_auth/companies/$id_/speakers': typeof AuthCompaniesIdSpeakersRoute
  '/_auth/meetings/$id_/transcript': typeof AuthMeetingsIdTranscriptRoute
  '/_auth/meetings/$id_/viewer': typeof AuthMeetingsIdViewerRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/two-factor'
    | '/ask'
    | '/audit'
    | '/campaigns'
    | '/diagnostics'
    | '/jargon'
    | '/members'
    | '/pipeline'
    | '/pipeline-runs'
    | '/platform-billing'
    | '/provider-credits'
    | '/search'
    | '/settings'
    | '/speakers'
    | '/tenant-usage'
    | '/usage'
    | '/invite/$id'
    | '/oauth/consent'
    | '/share/$token'
    | '/campaigns/$id'
    | '/companies/$id'
    | '/meetings/$id'
    | '/companies/'
    | '/companies/$id/diagnostics'
    | '/companies/$id/settings'
    | '/companies/$id/speakers'
    | '/meetings/$id/transcript'
    | '/meetings/$id/viewer'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/two-factor'
    | '/ask'
    | '/audit'
    | '/campaigns'
    | '/diagnostics'
    | '/jargon'
    | '/members'
    | '/pipeline'
    | '/pipeline-runs'
    | '/platform-billing'
    | '/provider-credits'
    | '/search'
    | '/settings'
    | '/speakers'
    | '/tenant-usage'
    | '/usage'
    | '/invite/$id'
    | '/oauth/consent'
    | '/share/$token'
    | '/'
    | '/campaigns/$id'
    | '/companies/$id'
    | '/meetings/$id'
    | '/companies'
    | '/companies/$id/diagnostics'
    | '/companies/$id/settings'
    | '/companies/$id/speakers'
    | '/meetings/$id/transcript'
    | '/meetings/$id/viewer'
  id:
    | '__root__'
    | '/_auth'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/two-factor'
    | '/_auth/ask'
    | '/_auth/audit'
    | '/_auth/campaigns'
    | '/_auth/diagnostics'
    | '/_auth/jargon'
    | '/_auth/members'
    | '/_auth/pipeline'
    | '/_auth/pipeline-runs'
    | '/_auth/platform-billing'
    | '/_auth/provider-credits'
    | '/_auth/search'
    | '/_auth/settings'
    | '/_auth/speakers'
    | '/_auth/tenant-usage'
    | '/_auth/usage'
    | '/invite/$id'
    | '/oauth/consent'
    | '/share/$token'
    | '/_auth/'
    | '/_auth/campaigns_/$id'
    | '/_auth/companies/$id'
    | '/_auth/meetings/$id'
    | '/_auth/companies/'
    | '/_auth/companies/$id_/diagnostics'
    | '/_auth/companies/$id_/settings'
    | '/_auth/companies/$id_/speakers'
    | '/_auth/meetings/$id_/transcript'
    | '/_auth/meetings/$id_/viewer'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TwoFactorRoute: typeof TwoFactorRoute
  InviteIdRoute: typeof InviteIdRoute
  OauthConsentRoute: typeof OauthConsentRoute
  ShareTokenRoute: typeof ShareTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/two-factor': {
      id: '/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof TwoFactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/share/$token': {
      id: '/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof ShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$id': {
      id: '/invite/$id'
      path: '/invite/$id'
      fullPath: '/invite/$id'
      preLoaderRoute: typeof InviteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/usage': {
      id: '/_auth/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof AuthUsageRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tenant-usage': {
      id: '/_auth/tenant-usage'
      path: '/tenant-usage'
      fullPath: '/tenant-usage'
      preLoaderRoute: typeof AuthTenantUsageRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/speakers': {
      id: '/_auth/speakers'
      path: '/speakers'
      fullPath: '/speakers'
      preLoaderRoute: typeof AuthSpeakersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/search': {
      id: '/_auth/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthSearchRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/provider-credits': {
      id: '/_auth/provider-credits'
      path: '/provider-credits'
      fullPath: '/provider-credits'
      preLoaderRoute: typeof AuthProviderCreditsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/platform-billing': {
      id: '/_auth/platform-billing'
      path: '/platform-billing'
      fullPath: '/platform-billing'
      preLoaderRoute: typeof AuthPlatformBillingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pipeline-runs': {
      id: '/_auth/pipeline-runs'
      path: '/pipeline-runs'
      fullPath: '/pipeline-runs'
      preLoaderRoute: typeof AuthPipelineRunsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pipeline': {
      id: '/_auth/pipeline'
      path: '/pipeline'
      fullPath: '/pipeline'
      preLoaderRoute: typeof AuthPipelineRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/members': {
      id: '/_auth/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof AuthMembersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/jargon': {
      id: '/_auth/jargon'
      path: '/jargon'
      fullPath: '/jargon'
      preLoaderRoute: typeof AuthJargonRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/diagnostics': {
      id: '/_auth/diagnostics'
      path: '/diagnostics'
      fullPath: '/diagnostics'
      preLoaderRoute: typeof AuthDiagnosticsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/campaigns': {
      id: '/_auth/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof AuthCampaignsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/audit': {
      id: '/_auth/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthAuditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/ask': {
      id: '/_auth/ask'
      path: '/ask'
      fullPath: '/ask'
      preLoaderRoute: typeof AuthAskRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/companies/': {
      id: '/_auth/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthCompaniesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/meetings/$id': {
      id: '/_auth/meetings/$id'
      path: '/meetings/$id'
      fullPath: '/meetings/$id'
      preLoaderRoute: typeof AuthMeetingsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/companies/$id': {
      id: '/_auth/companies/$id'
      path: '/companies/$id'
      fullPath: '/companies/$id'
      preLoaderRoute: typeof AuthCompaniesIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/campaigns_/$id': {
      id: '/_auth/campaigns_/$id'
      path: '/campaigns/$id'
      fullPath: '/campaigns/$id'
      preLoaderRoute: typeof AuthCampaignsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/meetings/$id_/viewer': {
      id: '/_auth/meetings/$id_/viewer'
      path: '/meetings/$id/viewer'
      fullPath: '/meetings/$id/viewer'
      preLoaderRoute: typeof AuthMeetingsIdViewerRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/meetings/$id_/transcript': {
      id: '/_auth/meetings/$id_/transcript'
      path: '/meetings/$id/transcript'
      fullPath: '/meetings/$id/transcript'
      preLoaderRoute: typeof AuthMeetingsIdTranscriptRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/companies/$id_/speakers': {
      id: '/_auth/companies/$id_/speakers'
      path: '/companies/$id/speakers'
      fullPath: '/companies/$id/speakers'
      preLoaderRoute: typeof AuthCompaniesIdSpeakersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/companies/$id_/settings': {
      id: '/_auth/companies/$id_/settings'
      path: '/companies/$id/settings'
      fullPath: '/companies/$id/settings'
      preLoaderRoute: typeof AuthCompaniesIdSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/companies/$id_/diagnostics': {
      id: '/_auth/companies/$id_/diagnostics'
      path: '/companies/$id/diagnostics'
      fullPath: '/companies/$id/diagnostics'
      preLoaderRoute: typeof AuthCompaniesIdDiagnosticsRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthAskRoute: typeof AuthAskRoute
  AuthAuditRoute: typeof AuthAuditRoute
  AuthCampaignsRoute: typeof AuthCampaignsRoute
  AuthDiagnosticsRoute: typeof AuthDiagnosticsRoute
  AuthJargonRoute: typeof AuthJargonRoute
  AuthMembersRoute: typeof AuthMembersRoute
  AuthPipelineRoute: typeof AuthPipelineRoute
  AuthPipelineRunsRoute: typeof AuthPipelineRunsRoute
  AuthPlatformBillingRoute: typeof AuthPlatformBillingRoute
  AuthProviderCreditsRoute: typeof AuthProviderCreditsRoute
  AuthSearchRoute: typeof AuthSearchRoute
  AuthSettingsRoute: typeof AuthSettingsRoute
  AuthSpeakersRoute: typeof AuthSpeakersRoute
  AuthTenantUsageRoute: typeof AuthTenantUsageRoute
  AuthUsageRoute: typeof AuthUsageRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthCampaignsIdRoute: typeof AuthCampaignsIdRoute
  AuthCompaniesIdRoute: typeof AuthCompaniesIdRoute
  AuthMeetingsIdRoute: typeof AuthMeetingsIdRoute
  AuthCompaniesIndexRoute: typeof AuthCompaniesIndexRoute
  AuthCompaniesIdDiagnosticsRoute: typeof AuthCompaniesIdDiagnosticsRoute
  AuthCompaniesIdSettingsRoute: typeof AuthCompaniesIdSettingsRoute
  AuthCompaniesIdSpeakersRoute: typeof AuthCompaniesIdSpeakersRoute
  AuthMeetingsIdTranscriptRoute: typeof AuthMeetingsIdTranscriptRoute
  AuthMeetingsIdViewerRoute: typeof AuthMeetingsIdViewerRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAskRoute: AuthAskRoute,
  AuthAuditRoute: AuthAuditRoute,
  AuthCampaignsRoute: AuthCampaignsRoute,
  AuthDiagnosticsRoute: AuthDiagnosticsRoute,
  AuthJargonRoute: AuthJargonRoute,
  AuthMembersRoute: AuthMembersRoute,
  AuthPipelineRoute: AuthPipelineRoute,
  AuthPipelineRunsRoute: AuthPipelineRunsRoute,
  AuthPlatformBillingRoute: AuthPlatformBillingRoute,
  AuthProviderCreditsRoute: AuthProviderCreditsRoute,
  AuthSearchRoute: AuthSearchRoute,
  AuthSettingsRoute: AuthSettingsRoute,
  AuthSpeakersRoute: AuthSpeakersRoute,
  AuthTenantUsageRoute: AuthTenantUsageRoute,
  AuthUsageRoute: AuthUsageRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthCampaignsIdRoute: AuthCampaignsIdRoute,
  AuthCompaniesIdRoute: AuthCompaniesIdRoute,
  AuthMeetingsIdRoute: AuthMeetingsIdRoute,
  AuthCompaniesIndexRoute: AuthCompaniesIndexRoute,
  AuthCompaniesIdDiagnosticsRoute: AuthCompaniesIdDiagnosticsRoute,
  AuthCompaniesIdSettingsRoute: AuthCompaniesIdSettingsRoute,
  AuthCompaniesIdSpeakersRoute: AuthCompaniesIdSpeakersRoute,
  AuthMeetingsIdTranscriptRoute: AuthMeetingsIdTranscriptRoute,
  AuthMeetingsIdViewerRoute: AuthMeetingsIdViewerRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TwoFactorRoute: TwoFactorRoute,
  InviteIdRoute: InviteIdRoute,
  OauthConsentRoute: OauthConsentRoute,
  ShareTokenRoute: ShareTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
